import { FavouriteRatingName } from '../enums';

export const FavouritesRatingCategory = [
  { name: FavouriteRatingName.Neighborhood, label: 'Neighborhood' },
  { name: FavouriteRatingName.InteriorCondition, label: 'Interior Condition' },
  { name: FavouriteRatingName.InteriorLayout, label: 'Interior Layout' },
  { name: FavouriteRatingName.Exterior, label: 'Exterior' },
  { name: FavouriteRatingName.Commute, label: 'Commute' },
  { name: FavouriteRatingName.Price, label: 'Price' },
  { name: FavouriteRatingName.OfferLikelihood, label: 'Likelihood of making an offer' },
];
export const DEFAULT_NOTES = {
  ratings: {},
};
